<template>
    <div class="home">
        <Header />
        <div class="container">
            <table class="table table-bordered" style="margin-top: 50px;">
                <thead>
                    <tr>
                        <th class="text-primary">Task</th>
                        <th class="text-primary">Reporter</th>
                        <th class="text-primary">Created</th>
                        <th class="text-primary">Priority</th>
                        <th class="text-primary">Status</th>
                    </tr>
                </thead> 
                <tbody> 
                    <tr v-for="task in tasks" :key="task.id"> 
                        <td @click="goToSingleTask(task.id)">{{task.name}}</td> 
                        <td @click="goToSingleTask(task.id)">XX</td> 
                        <td @click="goToSingleTask(task.id)">09/18/2019</td>
                        <td @click="goToSingleTask(task.id)">
                            <span v-if="task.priority == 0" class="label label-low">Low</span>
                            <span v-if="task.priority == 1" class="label label-warning">Medium</span>
                            <span v-if="task.priority == 2" class="label label-danger">High</span>
                        </td>
                        <td @click="goToSingleTask(task.id)">
                            <span v-if="task.status == 0" class="label label-pending">Pending</span>
                            <span v-if="task.status == 1" class="label label-primary">Started</span>
                            <span v-if="task.status == 2" class="label label-success">Completed</span>
                        </td>
                    </tr> 
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getJWT,getHeaders} from '../logic/global'
import {getTasks} from '../logic/task'
import Header from '../components/Header'


let tasks = []

export default {
    name: 'Home',
    components: {Header},
    computed: mapGetters(["getWorkspaceId"]),
    data() {
        return {
            tasks: tasks
        }
    },
    methods: {
        goToSingleTask: function(task_id){
            this.$router.push({name: 'task_single', params: {task_id: task_id}})
        },
        _getTasks: function(){
            getTasks(this.getWorkspaceId).then(response => {
                this.tasks = response.data.results;
            }).catch(error => {
                showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
        },
        showSuccessMsg: function(message, msg_type){
            this.$toast.open({message: message, type: msg_type})
        },
    },
    mounted: function(){
       this._getTasks()
    }
}
</script>

<style scoped>
    .table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
        padding: 15px !important;
    }
    .table tr:hover td{
        background: #abd7f1;
        cursor: pointer;
    }
</style>
